export function mapIfDefined<T, U>(data: T | undefined | null, mapFn: (data: T) => U): U | undefined {
    return data !== undefined && data !== null ? mapFn(data) : undefined
}
